<template>
  <div id="parks-landing">
    <div class="filters-wrapper" ref="filtersWrapper" v-show="displayfilters">
      <div class="container">
        <aside :aria-label="$t('Filtres')">
          <ParksLandingSearch
              ref="parkSearchComponent"
              :userLocation="userLocation"
              :isMobile="isMobile"
              :lang="$i18n.locale"
              :urlbinding="urlbinding"
              :displayfilters="displayfilters"
              :displayresult="displayresult"
              @applyFacet="applyFacet"
              :facets="facets"
              :page="currentPage"
              :areParksLoaded="areParksLoaded"
          />
        </aside>
      </div>

    </div>
    <div id="filters-result" class="container" v-if="displayresult">
      <h2 v-if="resultCount !== null && resultCount > 0" ref="resultHeading" tabindex="-1" class="heading-body-color">
        {{ resultCount }} {{ $tc('résultat', resultCount)}}
      </h2>
      <div v-if="resultCount !== null && resultCount == 0" class="filters-noresult">
        <h2  ref="resultHeading" tabindex="-1" class="heading-body-color">
        {{ resultCount }} {{ $tc('résultat', resultCount)}}
        </h2>
        <img class="filters-noresult__img" src="../../../images/noresult.png" alt="">
        <p class="filters-noresult__msg lead">
          {{ $t("Aucun espace vert") }}
        </p>
        <btn class="btn btn-primary" @click="resetSearch">
          {{ $t("Réinitialiser les filtres") }}
        </btn>
      </div>
    </div>

    

    <div class="loader-wrapper" v-if="!areParksLoaded && showLoader">
      <div class="loader"></div>
    </div>

    <div class="main-wrapper">
      <SidedPanes
        :sided="isSided"
        v-if="areParksLoaded && resultCount > 0"
        >

        <template v-slot:leftPane>
          
            <ParksList
              :parks="parks"
              :breakpoint="$mq"
            />
          
        </template>
        <template v-slot:rightPane>
          <ParksLFMap
            ref="mapComponent"
            v-if="areParksLoaded"
            :isMobile="isMobile"
            :parks="parks"
            :activatedPark="activatedPark"
            :userLocation="userLocation"
            @markerSelected="onMarkerSelected"/>
        </template>
        <template v-slot:leftButton>
          <span class="button-icon" aria-hidden="true">
              <svg class="micon icm-map" aria-hidden="true">
                <use v-bind="{'xlink:href' : appSettings.drupalApiUri + 'sites/default/files/micon/icm/symbol-defs.svg#icm-list'}"></use>
              </svg>
          </span>
            {{ $t('Afficher la liste') }}
        </template>
        <template v-slot:rightButton>
          <span class="button-icon" aria-hidden="true">
              <svg class="micon icm-map" aria-hidden="true">
                <use v-bind="{'xlink:href' : appSettings.drupalApiUri + 'sites/default/files/micon/icm/symbol-defs.svg#icm-map'}"></use>
              </svg>
          </span>
          {{ $t('Afficher la carte') }}
        </template>
      </SidedPanes>
    </div>

    <div class="map-bottom-popup" position="bottomleft" v-if="markerSelected && isMobile">
      <button type="button"
        :aria-label="$t('Fermer')"
        class="btn-close text-reset"
        @click="markerSelected=null">
      </button>
      <ParkCardMap :park=markerSelected.park />
    </div>
    
  </div>
</template>

<script>


import { appSettings } from "../../../../vuejs/vuejs_master/src/config/config";
import axios from 'axios';
import SidedPanes from '../../../../vuejs/vuejs_master/src/components/SidedPanes.vue'
import ParksLandingSearch from '../../parks-landing-search/parks-landing-search.vue';
import ParksList from '../../parks-list/parks-list.vue';
import ParkCardMap from '../../park-card-map/park-card-map.vue';

// Use svg-loader (https://github.com/visualfanatic/vue-svg-loader)
//import iconMap  from "../../../vuejs_master/src/assets/icons/icon-map.svg?inline";
//import iconList  from "../../../vuejs_master/src/assets/icons/icon-list.svg?inline";

import { getOpeningStatus } from '../../parks-opening-hours/src/helpers';

export default {
  name: 'ParksLanding',
  components: {
    SidedPanes,
    ParksLandingSearch,
    ParksList,
    ParksLFMap: () => import('../../parks-lf-map/parks-lf-map.vue'),
    ParkCardMap
  },

  data() {
    return {
      appSettings: appSettings,
      queryUrl: '',
      parks: [],
      facets: [
      {
          machineName: 'title',
          label: 'Parc',
          values: [],
          filter: true
        },
        {
          machineName: 'city_name',
          label: 'Commune',
          values: [],
          filter: false
        },
        {
          machineName: 'equipment_name',
          label: 'Equipement',
          values: [],
          filter: false
        },
        {
          machineName: 'type_name',
          label: 'Type d\'espace',
          values: [],
          filter: false,
        },
        {
          machineName: 'faune_name',
          label: 'Faune',
          values: [],
          filter: true
        },
        {
          machineName: 'flore_name',
          label: 'Flore',
          values: [],
          filter: true
        },
        {
          machineName: 'thema_name',
          label: 'Thématique',
          values: [],
          filter: false,
        }
        
      ],
      resultCount: null,
      currentPage: 1,
      areParksLoaded: false,
      userLocation: null,
      geoLocated: false,
      activatedPark: null, // Park hovered in the list
      markerSelected: null,
      isMapShown: false,
      isFiltered: null,
      showLoader: true
    }
  },

  props: {
    urlbinding: {
      type: Boolean,
      default: false
    },
    displayfilters: {
      type: Boolean,
      default: false
    },
    displayresult: {
      type: Boolean,
      default: true
    },
    filters: {
      type: Array,
      default: function(){ 
        return [
          // Parks
          {
            fieldName: 'nid',
            criteria: [],
          },
          // Cities
          {
            fieldName: 'cities',
            criteria: [],
          },
          // Equipment
          {
            fieldName: 'equipment',
            criteria: [],
          },
          // Types
          {
            fieldName: 'type',
            criteria: [],
          },
          // Fauna
          {
            fieldName: 'faune',
            criteria: [],
          },
          // Flora
          {
            fieldName: 'flora',
            criteria: [],
          },
          // Themas
          {
            fieldName: 'themas',
            criteria: [],
          },
        ]
      }
    }
  },

  computed: {
    isMobile() {
      const mobileBreakpoints = ['xs', 'sm', 'md', 'lg'];
      return mobileBreakpoints.includes(this.$mq);
    },
    isSided() {
      // Are list and map panes displayed side by side?
      // For now, always not sided
      return false;
    },
    
  },


  
  mounted(){
    //this.$i18n.locale = 'nl';
    this.loadConfig();
    this.geolocate();  


    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        this.$refs.filtersWrapper.classList.add('is-stuck');
      } else {
        this.$refs.filtersWrapper.classList.remove('is-stuck');
      }
    });


    const currentUrl = window.location.href;
    const queryString = currentUrl.split('?')[1];
    this.url = appSettings.drupalApiUri + this.$i18n.locale + '/api/v3/parks';
    if (queryString) {
      this.url += '?' + queryString;
    }

    this.applyFacet(this.url, null);

  },

  methods: {
    getOpeningStatus,
    async loadConfig() {
      let url = appSettings.drupalApiUri + this.$i18n.locale
                  + '/rest_api/parks_config';

      axios
        .get(url)
        .then(response => localStorage.setItem('parks_config', JSON.stringify(response.data.config)))
        .catch(error => localStorage.setItem('parks_config', error + ': ' + url));

    },

  

    async applyFacet(url, checkedFacets) {
      
      this.areParksLoaded = false;
      this.showLoader = checkedFacets ? false : true;
      this.queryUrl = url;
      const response = await fetch(this.queryUrl);
      const data = await response.json();
      
      this.parks = data.search_results;
      data.facets.forEach(facetArray => {
        facetArray.forEach(facetObj => {
          
          for (const key in facetObj) {
            const facet = this.facets.find(f => f.machineName === key);
            
            if (facet) {
              facet.values = facetObj[key];
            }
          }
        });
      });
      
      
      const regex = /ranges="([^"]*)"/;
      this.parks.forEach((park, i) => {
        let parkType = park.park_hours_type;

        if (park.status == 1){
          // park.status=true means that there is no general closure neither specific closure
          if (parkType == 'CLOSED' || parkType == 'NOTCLOSED'){
            let rangesString = park.openinghoursRendered;
            
            let match = rangesString.match(regex);
            if (match){
              let rangesValue = match[1];
              let jsonString = rangesValue.replace(/&quot;/g, '"');
              let ranges = JSON.parse(jsonString);
              let status = getOpeningStatus(ranges, parkType);
              
              this.$set(this.parks[i], 'isOpen', status.isOpen);
              this.$set(this.parks[i], 'ranges', ranges);
              
            }
          }else{
            this.$set(this.parks[i], 'isOpen', true);
          }
        }else{
          // Genral or specific closure
          this.$set(this.parks[i], 'isOpen', false);
        }
        
      });
      
      this.resultCount = data.search_results.length;
      this.areParksLoaded = true;
    },

    onMarkerSelected(marker) {
      this.markerSelected = marker ? marker : null;
    },
    // Geolocation
    async geolocate() {
      try {
        let position = await this.getLocation();
        this.userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.geoLocated = true;
      } catch(e) {
        this.errorStr = e.message;
        this.geoLocated = false;
      }

    },

    async getLocation() {

      return new Promise((resolve, reject) => {

        if(!("geolocation" in navigator)) {
          reject(new Error('Geolocation is not available.'));
        }
        const options = {
          enableHighAccuracy: false,
          timeout: 5000,
          maximumAge: 60000,
        };
        navigator.geolocation.getCurrentPosition(pos => {
          resolve(pos);
        }, err => {
          reject(err);
        }, options);

      });
    },

  }
}

</script>

<style>
.filters-wrapper{
  @media (min-width: 1280px){
    position: sticky;
  }
  top: -1px; 
  z-index: 1002;
  background-color: white;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.filters-wrapper.is-stuck{
  @media (min-width: 1280px){
    border-bottom: 1px solid rgba(0, 0, 0, .12);;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2);;
  }
}
aside{
  width: 100%;
}
.filters-wrapper .container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 3rem;
}

#filters-result{
  margin-top: 2rem;
  text-align: center;
  display: flex;
  justify-content: center;
}
.filters-noresult{
  width: 28rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  align-items: center;
}
.filters-noresult__img{
  width: 15rem;
  height: 15rem;
  object-fit: cover;
  border-radius: 100%;
  margin: 2rem;
}
.main-wrapper{
  margin-top: 1rem;
}
.modal-backdrop{
  z-index: 1 !important;
}
.loader-wrapper{
  display: flex;
  justify-content: center;
}

.loader {
  width: 48px;
  height: 48px;
  border: 3px solid #c1ddda;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader::after {
  content: '';  
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid;
  border-color: #007268 transparent;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} 

</style>

